import type { Messages } from "./en";
export const ja: Messages = {
  "meta.title": "ArtLove365 - 手描きの油絵",
  "meta.description": "世界の名画を画家が一枚ずつ手描きで再現した油絵と、お客様の写真から描くオーダーメイドの油絵肖像画。",
  "nav.gallery": "ギャラリー",
  "nav.artists": "画家",
  "nav.custom": "写真を油絵に",
  "nav.track": "注文状況",
  "home.eyebrow": "本物の画家が、油絵具で一枚ずつ手描き",
  "home.title": "名画をあなたの壁に。思い出を名画のように。",
  "home.subtitle": "歴史に残る名画から選ぶか、お手持ちの写真をアップロードしてください。画家がキャンバスに手描きし、ご自宅までお届けします。",
  "home.ctaGallery": "ギャラリーを見る",
  "home.ctaCustom": "写真をアップロード",
  "home.stepsTitle": "ご注文の流れ",
  "home.step1Title": "選ぶ・アップロード",
  "home.step1Body": "名画を選ぶか、ご家族・ペット・思い出の場所の写真をアップロードします。",
  "home.step2Title": "画家が描く",
  "home.step2Body": "プロの油彩画家が本物のキャンバスに描きます。オーダーメイドは下絵をご確認いただいてから制作します。",
  "home.step3Title": "お届け",
  "home.step3Body": "乾燥後、丁寧に梱包し、追跡番号付きで世界中へ発送します。",
  "home.featured": "おすすめの名画",
  "gallery.title": "名画ギャラリー",
  "gallery.subtitle": "すべて油絵具によるキャンバスへの手描き再現です。印刷ではありません。",
  "gallery.filterAll": "すべての画家",
  "gallery.empty": "作品が見つかりません。",
  "artists.title": "巨匠たち",
  "artists.works": "作品を見る",
  "artwork.by": "作：",
  "artwork.order": "この作品を注文する",
  "artwork.notFound": "この作品は見つかりませんでした。",
  "order.size": "キャンバスサイズ",
  "order.frame": "仕上げ",
  "frame.rolled": "ロールキャンバス（筒に入れて発送）",
  "frame.stretched": "木枠張り（そのまま飾れます）",
  "frame.framed": "木枠張り＋木製額縁",
  "order.subjects": "写真に写っている人数・ペットの数",
  "order.price.base": "絵画",
  "order.price.frame": "仕上げ",
  "order.price.custom": "オーダーメイド肖像画",
  "order.price.shipping": "送料",
  "order.price.free": "無料",
  "order.price.total": "合計",
  "order.contact": "お届け先",
  "order.name": "氏名",
  "order.email": "メールアドレス",
  "order.phone": "電話番号",
  "order.address": "住所",
  "order.city": "市区町村",
  "order.postalCode": "郵便番号",
  "order.country": "国",
  "order.notes": "画家へのご要望（任意）",
  "order.submit": "お支払いへ進む",
  "order.submitting": "ご注文を処理しています…",
  "order.error": "エラーが発生しました。入力内容をご確認のうえ、もう一度お試しください。",
  "order.leadTime": "制作に2〜3週間、発送前の乾燥に1週間かかります。",
  "custom.title": "写真を油絵に",
  "custom.subtitle": "ピントが合った明るい写真をアップロードしてください。画家が手描きします。制作前に下絵をご確認いただけます。",
  "custom.upload": "写真を選ぶ",
  "custom.uploadHint": "JPG・PNG・WebP、20MBまで。解像度が高いほど仕上がりが良くなります。",
  "custom.uploading": "アップロード中…",
  "custom.uploaded": "アップロード完了",
  "custom.replace": "別の写真にする",
  "custom.style": "画風",
  "custom.style.classic": "古典的な写実",
  "custom.style.impressionist": "印象派（モネ風）",
  "custom.style.vangogh": "力強い筆致（ゴッホ風）",
  "custom.style.modern": "モダン・やわらかな色調",
  "custom.needPhoto": "先に写真をアップロードしてください。",
  "track.title": "注文状況の確認",
  "track.code": "注文番号",
  "track.submit": "検索",
  "track.notFound": "この注文番号とメールアドレスに一致する注文は見つかりませんでした。",
  "track.placed": "注文日",
  "success.title": "ありがとうございます。ご注文を承りました。",
  "success.body": "確認メールをお送りしました。進捗の確認には注文番号をお使いください。",
  "status.awaiting_payment": "お支払い待ち",
  "status.paid": "お支払い済み",
  "status.sketching": "下絵制作中",
  "status.painting": "制作中",
  "status.drying": "乾燥中",
  "status.shipped": "発送済み",
  "status.delivered": "お届け済み",
  "status.cancelled": "キャンセル",
  "common.loading": "読み込み中…",
  "common.back": "戻る",
  "footer.tagline": "手描きの油絵を世界中へお届けします。",
  "footer.follow": "フォローする",
  "footer.docs": "ヘルプ・ドキュメント",
  "gallery.search": "作品名・画家名で検索…",
  "sketch.title": "下絵ができました",
  "sketch.body": "構図をご確認ください。ご承認後に制作を開始します。",
  "sketch.approve": "下絵を承認する",
  "sketch.change": "修正を依頼する",
  "sketch.feedback": "修正してほしい点をお書きください",
  "sketch.send": "送信",
  "sketch.approved": "下絵を承認いただきました。制作を開始しています。",
  "sketch.changesSent": "ありがとうございます。修正した下絵をお送りします。",
  "checkout.title": "お支払い",
  "checkout.demoBanner": "デモモード：オンライン決済はまだ開始していません。料金は請求されず、カード情報も収集しません。",
  "checkout.summary": "ご注文内容",
  "checkout.method": "お支払い方法",
  "checkout.method.card": "クレジット／デビットカード",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay／Google Pay",
  "checkout.method.bank": "銀行振込",
  "checkout.cardNumber": "カード番号",
  "checkout.expiry": "有効期限（MM/YY）",
  "checkout.cvc": "セキュリティコード",
  "checkout.cardName": "カード名義",
  "checkout.paypalNote": "PayPalに移動してお支払いを承認していただきます。",
  "checkout.walletNote": "Face ID、Touch ID、またはスマートフォンで承認してください。",
  "checkout.bankNote": "振込先をメールでお送りします。ご入金の確認後に制作を開始します（1〜3営業日）。",
  "checkout.pay": "{amount} を支払う",
  "checkout.processing": "お支払いを処理しています…",
  "checkout.secure": "お支払いは暗号化され、決済代行会社が処理します。カード番号を当社が保存することはありません。",
  "checkout.demoDoneTitle": "お支払い（デモ）完了",
  "checkout.demoDoneBody": "これはデモです。料金は請求されていません。ご注文は保存され「お支払い待ち」のままです。お支払い方法について担当者からご連絡します。",
  "checkout.failTitle": "お支払いが承認されませんでした",
  "checkout.failBody": "カード会社によりお支払いが拒否されました。入力内容をご確認いただくか、別の方法をお試しください。",
  "checkout.retry": "もう一度試す",
  "checkout.viewOrder": "注文を確認する",
  "track.payNow": "今すぐ支払う",
  "browse.title": "探す",
  "browse.movements": "美術運動",
  "browse.museums": "美術館",
  "browse.subjects": "主題",
  "browse.genres": "ジャンル",
  "artwork.year": "制作年",
  "artwork.size": "原画サイズ",
  "artwork.museum": "所蔵",
  "artwork.movement": "美術運動",
  "artwork.genre": "ジャンル",
  "artwork.subjects": "主題",
  "artwork.moreBy": "同じ画家の作品：",
  "pager.prev": "前へ",
  "pager.next": "次へ",
  "count.paintings": "{n}点",
  "fav.add": "お気に入りに追加",
  "fav.remove": "お気に入りから削除",
  "fav.title": "お気に入り",
  "fav.empty": "お気に入りはまだありません。気に入った作品のハートをタップすると、ここに保存されます。",
  "fav.emptyCta": "ギャラリーを見る",
  "fav.syncHint": "Googleでログインすると、どの端末でもお気に入りを見られます。",
  "fav.saved": "お気に入りに保存しました",
  "fav.nav": "お気に入り",
  "account.signIn": "ログイン",
  "account.signOut": "ログアウト",
  "account.signedInAs": "ログイン中：",
  "account.signInTitle": "ArtLove365にログイン",
  "viewer.open": "全画面で見る",
  "viewer.close": "閉じる",
  "viewer.hint": "スクロールまたはピンチで拡大・ドラッグで移動・ダブルクリックで元に戻す",
  "share.button": "共有",
  "share.copied": "リンクをコピーしました",
  "artwork.story": "この作品について",
  "artwork.details": "作品情報",
  "artwork.aboutArtist": "画家について",
  "artwork.readArtist": "{name}の生涯を読む",
  "artwork.relatedArtists": "関連する画家の作品",
  "rel.influenced_by": "{artist}に影響を与えた",
  "rel.influenced": "{artist}の影響を受けた",
  "rel.student_of": "{artist}の師",
  "rel.student": "{artist}の弟子",
  "rel.movement": "同じ{movement}",
  "story.didYouKnow": "豆知識",
  "story.sources": "出典",
  "story.aiNote": "以下の出典をもとにAIの助けを借りて執筆しました。誤りにお気づきの際はお知らせください。",
  "artist.relatedArtists": "関連する画家",
  "artist.worksBy": "{name}の作品",
  "nav.how": "制作のこだわり",
  "home.ctaArtists": "画家に出会う",
  "home.discover": "ArtLove365について",
  "home.howCardTitle": "制作のこだわり",
  "home.howCardBody": "本物の画家、本物のキャンバス、油絵具、そして時間。名画が手描きでよみがえる過程をご紹介します。",
  "home.customCardTitle": "あなたの写真を油絵に",
  "home.customCardBody": "家族、カップル、ペット、育った家--写真が一枚の絵になるまでをご覧ください。",
  "home.featuredArtists": "巨匠たちに出会う",
  "home.browseMovements": "美術運動から探す",
  "common.readMore": "詳しく見る",
  "how.title": "制作のこだわり",
  "how.intro": "ArtLove365の作品はすべて、プロの画家が本物のキャンバスに油絵具で一枚ずつ手描きしています。印刷も近道もありません。名画があなたの壁に届くまでをご紹介します。",
  "how.s1t": "心に響く一枚から",
  "how.s1b": "数千点の名画を巡り、作品の物語を読み、心に残った作品をお気に入りに保存しましょう。",
  "how.s2t": "画家が原画を研究する",
  "how.s2b": "最初の一筆の前に、構図や色彩、巨匠の絵具の置き方を研究します。色と同じくらい、塗り重ねる順番が大切です。",
  "how.s3t": "一層ずつ、手で描く",
  "how.s3b": "油彩はゆっくりと積み上げます。下塗り、大きな面、そして細部とグレーズ。中サイズのキャンバスで2〜3週間かかります。",
  "how.s4t": "検品し、乾燥させる",
  "how.s4b": "経験豊かな画家が原画と見比べて確認します。その後、安全に輸送できるよう約1週間乾燥させます。",
  "how.s5t": "丁寧に梱包し、世界へ",
  "how.s5b": "作品は丈夫な筒に丸めて、または木枠に張って補強箱に入れ、追跡番号付きでお届けします。",
  "how.materialsTitle": "素材",
  "how.materialsBody": "専門家用の油絵具、下地処理済みの綿または麻のキャンバス、そして画面を長年守るワニス。",
  "how.customTitle": "お手持ちの写真から描く場合",
  "how.customBody": "肖像画やプライベートな情景では、描き始める前に構図の下絵をご確認いただく工程が加わります。",
  "custom.pageTitle": "写真から描くオーダーメイド油絵",
  "custom.pageIntro": "写真は一瞬を残し、絵画はそれを永遠にします。画家がお手持ちの写真を、お好みの画風で手描きの油彩の肖像画や情景に仕上げます。",
  "custom.howTitle": "制作の流れ",
  "custom.step1t": "写真を共有する",
  "custom.step1b": "鮮明な写真が1枚あれば十分です。複数の写真を1つの場面にまとめることもできます。",
  "custom.step2t": "下絵を確認する",
  "custom.step2b": "画家が構図を用意します。ご納得いただくまで描き始めません。",
  "custom.step3t": "手で描く",
  "custom.step3b": "選んだ画風で、キャンバスに油彩を一層ずつ重ねます。",
  "custom.step4t": "お手元へ",
  "custom.step4b": "乾燥と最終確認のあと、梱包して追跡番号付きで発送します。",
  "custom.stylesTitle": "画風を選ぶ",
  "custom.styleDesc.classic": "古典の巨匠の伝統に倣った、忠実な似姿、やわらかな光、繊細な描写。",
  "custom.styleDesc.impressionist": "モネの夏の午後のような、軽やかで生き生きとした筆触で描く光と空気。",
  "custom.styleDesc.vangogh": "ゴッホに着想を得た、厚く渦巻く筆致と力強い色彩。",
  "custom.styleDesc.modern": "すっきりとした形とやわらかな現代的な色調。モダンなインテリアに。",
  "custom.occasionsTitle": "人気のテーマ",
  "custom.occ.family": "家族の肖像",
  "custom.occ.couples": "カップル・結婚",
  "custom.occ.pets": "ペット",
  "custom.occ.children": "子ども",
  "custom.occ.memorial": "大切な人の思い出に",
  "custom.occ.home": "家や思い出の場所",
  "custom.tipsTitle": "写真選びのコツ",
  "custom.tip1": "ピントが合っていること、特に目元。",
  "custom.tip2": "やわらかな自然光で。強いフラッシュや加工は避けてください。",
  "custom.tip3": "表情がはっきり分かる大きさで写っていること。",
  "custom.tip4": "写真が複数ある場合も、人物やペットを1枚の絵にまとめられます。",
  "custom.explore": "ギャラリーで画風を探す",
  "showcase.title": "これまでに描いた作品",
  "showcase.subtitle": "お客様のために描いた実際の作品を、ご本人の許可を得て掲載しています。",
  "showcase.all": "すべて",
  "custom.occ.nail": "ネイルサロンの装飾",
  "custom.occ.other": "その他",
  "home.newTitle": "新しく語られた物語",
  "home.newWhy": "物語が加わったばかりの作品。毎日新しい出会いがあります。",
  "home.gemsTitle": "知られざる名作",
  "home.gemsWhy": "有名ではなくても心を動かす作品。多くの人が素通りしてしまう一枚を。",
  "taxon.faqTitle": "{name}とは？ よくある質問",
  "notFound.title": "ページが見つかりません",
};
